export default __webpack_public_path__ + "static/media/logo-iqvia.74d5733b.svg";